/**
 * Check if a given object implements the UpdateLearningDomainInfoRequest interface.
 */
export function instanceOfUpdateLearningDomainInfoRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "description" in value;
    return isInstance;
}
export function UpdateLearningDomainInfoRequestFromJSON(json) {
    return UpdateLearningDomainInfoRequestFromJSONTyped(json, false);
}
export function UpdateLearningDomainInfoRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'displayName': json['displayName'],
        'description': json['description'],
    };
}
export function UpdateLearningDomainInfoRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'displayName': value.displayName,
        'description': value.description,
    };
}
